"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_hook_form_1 = require("react-hook-form");
const FormFieldFromProps_1 = __importDefault(require("@Fields/v2/FormFieldFromProps"));
const IdentifiersSection_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/IdentifiersSection"));
const IdentifiersTooltip_1 = __importDefault(require("@Scenes/SongwriterRegistrationScene/Tooltips/IdentifiersTooltip"));
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const react_1 = __importDefault(require("react"));
const create_songwriter_1 = require("@Entities/schemas/songwriter/create-songwriter");
const SongwriterRegistrationForm = (props) => {
    const { methods, onSubmit } = props;
    const { name, ipiNumber } = create_songwriter_1.createSongwriterFormFields;
    return (react_1.default.createElement("div", { className: 'songwriter-inputs' },
        react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
            react_1.default.createElement("form", { onSubmit: methods.handleSubmit(onSubmit) },
                react_1.default.createElement(FormFieldFromProps_1.default, { field: name }),
                react_1.default.createElement(IdentifiersSection_1.default, { ipiNumber: ipiNumber, identifierToolTip: react_1.default.createElement(IdentifiersTooltip_1.default, null) }),
                react_1.default.createElement(Button_1.Button, { type: 'primary', icon: common_1.ICONS.arrow_forward, mainColor: true, submitType: 'submit' }, "Next")))));
};
exports.default = SongwriterRegistrationForm;
